import {useEffect, useRef} from "react";
import React, {forwardRef} from 'react'

import PropTypes from "prop-types";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

import {Button} from "primereact/button";

export function VoucherPrint(props) {

    const printRef = useRef(null);

    const handleDownloadPdf = async () => {
        const element = printRef.current;
        if (!element) {
            return;
        }

        const canvas = await html2canvas(element, {
            scale: 2,
        });
        const data = canvas.toDataURL("image/png");

        const pdf = new jsPDF({
            orientation: "portrait",
            unit: "px",
            format: "a5",
        });

        const imgProperties = pdf.getImageProperties(data);
        const pdfWidth = pdf.internal.pageSize.getWidth();

        const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;
        const fileName = `VOUC-${props.data.id}.pdf`;
        pdf.addImage(data, "PNG", 0, 0, pdfWidth, pdfHeight);
        pdf.save(fileName);

    };


    return (
        <>

                <div className="min-h-screen bg-gray-100 p-8 flex flex-col items-center">
                    <div className="bg-white shadow-lg rounded-lg p-6 w-full max-w-2xl">
                        <div ref={printRef} className="p-4 bg-white border border-gray-200">
                            <div className="flex justify-content-between  mb-1">
                                <div>
                                    <h1 className="text-3xl font-bold text-gray-800">{props.companyName}</h1>
                                    <p className="text-sm text-gray-600">Voucher #{props.data.id}</p>
                                </div>
                                <h1 className="text-3xl font-bold text-gray-800">Voucher</h1>
                            </div>
                            <div className="flex justify-content-between mb-1">
                                <div>
                                    <h1 className="text-lg font-bold text-gray-800">Date :</h1>
                                    <p className="text-sm text-gray-600">{props.data.date}</p>
                                </div>
                            </div>

                            <table className="w-full mb-8 border-collapse">
                                <thead>
                                </thead>
                                <tbody>
                                <tr>{props.data.comment}
                                </tr>
                                <tr>
                                    <th className="bg-gray-100 border p-2 text-left">Description</th>
                                    <th className="bg-gray-100 border p-2 text-left">Code</th>
                                    <th className="bg-gray-100 border p-2 text-left">Name</th>
                                    <th className="bg-gray-100 border p-2 text-left">Department</th>
                                </tr>
                                <tr>
                                    <th className="bg-gray-100 border p-2 text-left">Debtor</th>
                                    <td className="border p-2 text-left">{props.data.debitId}</td>
                                    <td className="border p-2 text-left">{props.data.debitName}</td>
                                    <td className="border p-2 text-left">{props.data.debitDepName}</td>
                                </tr>
                                <tr>
                                    <th className="bg-gray-100 border p-2 text-left">Creditor</th>
                                    <td className="border p-2 text-left">{props.data.creditId}</td>
                                    <td className="border p-2 text-left">{props.data.creditName}</td>
                                    <td className="border p-2 text-left">{props.data.creditDepName}</td>
                                </tr>
                                <tr>
                                    <th className="bg-gray-100 border p-2 text-left">Amount</th>
                                    <td className="border p-2 text-right">{(props.data.amount.toLocaleString())}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className="mt-6 flex justify-center">
                            <Button className="mr-2"
                                    severity="warning"
                                    label="Print"
                                    icon="pi pi-print"
                                    onClick={handleDownloadPdf}>
                            </Button>
                            <Button
                                severity="warning"
                                label="Close"
                                icon="pi pi-sign-out"
                                onClick={() => props.setPrint(false)}>
                            </Button>
                        </div>


                    </div>
                </div>

        </>
    );
}

VoucherPrint.propTypes = {
    data: PropTypes.object.isRequired,
    setPrint: PropTypes.func.isRequired,
    companyName: PropTypes.string.isRequired,
}
